import React from 'react'
import { AppBar, Box, Container, Toolbar, Typography } from '@mui/material'
import { Link, Outlet } from 'react-router-dom'
import { ROUTES } from '../constants/routes'

// App shell shared by every route: a top bar plus an <Outlet /> for the active page. Nested
// layouts (e.g. an authenticated-area layout wrapping its own guard + Outlet) compose the same way
// — see RouterApp.tsx for how routes nest under this.
const BaseLayout: React.FC = () => {
  return (
    <Box display="flex" flexDirection="column" minHeight="100vh">
      <AppBar position="static">
        <Toolbar>
          <Typography
            variant="h6"
            component={Link}
            to={ROUTES.HOME}
            sx={{ color: 'inherit', textDecoration: 'none', flexGrow: 1 }}
          >
            Energy Planner Ui
          </Typography>
        </Toolbar>
      </AppBar>
      <Container component="main" sx={{ flex: 1, py: 4 }}>
        <Outlet />
      </Container>
    </Box>
  )
}

export default BaseLayout
